module.exports = __webpack_public_path__ + "img/shouye-xiangmuzhichi-png-02.527c9dd6.svg";